import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Containers/Home';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ListingDetail from './Containers/Pages/ListingDetail';
import CategoryListing from './Containers/Pages/CategoryListing';
import SearchResult from './Containers/Pages/SearchResult';
import { WishlistProvider } from './Components/Context/WishlistContext';
import AboutUs from './Containers/Pages/AboutUs';
import ContactUs from './Containers/Pages/ContactUs';
import PrivacyPolicy from './Containers/Pages/PrivacyPolicy';
import TermCondition from './Containers/Pages/TermCondition';



function App() {
  return (
    <div className="App">
      <WishlistProvider>
        <ToastContainer />
        <Router>

          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route exact path='/property-details/:room_name' element={<ListingDetail />} />
            <Route path="/category/:url" element={<CategoryListing />} />
            <Route path="/searchresult" element={<SearchResult />} />

            <Route exact path='/about-us' element={<AboutUs />} />
            <Route exact path='/contact-us' element={<ContactUs />} />
            <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route exact path='/terms-conditions' element={<TermCondition />} />



          </Routes>
        </Router>
      </WishlistProvider>
    </div>

  );
}

export default App;
